import './randypeters/style';
import FormStructure from './randypeters/form_structure';

export default FormStructure;